import { Box, Stack, Typography, styled } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import ExitWarningIcon from 'images/icons/exit-warning-icon.svg?react';
import { Button } from '../Button';
import { PrimaryDialog } from './PrimaryDialog';

const Content = styled(DialogContent)(({ theme }) => ({
    '&.MuiDialogContent-root': {
        padding: theme.spacing(5),
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
        alignItems: 'center',
        justifyContent: 'space-between',
    },
}));

const Message = styled(Typography)({
    fontSize: '0.875rem',
    lineHeight: '19px',
    fontWeight: 500,
    textAlign: 'center',
    fontFamily: '"General Sans", sans-serif',
});

const MessageContent = ({ message }: { message: React.ReactNode }) => {
    if (!message) return null;

    if (typeof message === 'string') {
        return <Message>{message}</Message>;
    }

    return <Box>{message}</Box>;
};

type ConfirmationDialogProps = {
    open: boolean;
    icon?: React.ReactNode;
    hideIcon?: boolean;
    title?: string;
    message: React.ReactNode;
    actionButtonText?: string;
    actionButtonLoading?: boolean;
    isDisabled?: boolean;
    cancelButtonText?: string;
    onDelete?: () => void;
    onCancel: () => void;
};

export function DeleteConfirmationDialog({
    open,
    hideIcon = false,
    icon = <ExitWarningIcon />,
    title = 'Are you sure?',
    message,
    cancelButtonText = 'Cancel',
    actionButtonText = 'Delete',
    actionButtonLoading = false,
    isDisabled = false,
    onDelete,
    onCancel,
}: ConfirmationDialogProps) {
    return (
        <PrimaryDialog width="586px" height="auto" open={open} onClose={onCancel}>
            <Content>
                {!hideIcon && icon}
                <Stack gap={1} width="100%">
                    <Typography variant="h5" fontWeight={700} textAlign="center" lineHeight="normal">
                        {title}
                    </Typography>
                    <MessageContent message={message} />
                </Stack>
                <Stack direction="row" width="100%" gap={2}>
                    <Button fullWidth variant="outline" onClick={onCancel}>
                        {cancelButtonText}
                    </Button>
                    <Button
                        fullWidth
                        autoFocus
                        onClick={onDelete ? onDelete : onCancel}
                        loading={actionButtonLoading}
                        disabled={isDisabled}
                        color="error"
                    >
                        {actionButtonText}
                    </Button>
                </Stack>
            </Content>
        </PrimaryDialog>
    );
}
